import React from "react";

import "./Toggle.css";

export const Toggle = ({active, setActive}) => {

    const handleClick = () => {
        setActive(!active);
    }

    return (
        <div className={"toggle-container " + (active ? "toggle-container-active" : "toggle-container-inactive")}
             aria-label={"toggle-button"} onClick={handleClick}>
            <div className={"toggle-slider " + (active ? "toggle-slider-active" : "toggle-slider-inactive")}/>
        </div>
    );
}
